import React from 'react';
import PropTypes from 'prop-types';

export default function AddButton({ id, isDisabled, submitAction }) {
    return (
        <div id={id} className="col-xs-12">
            <button
                type="button"
                className="spark-btn spark-btn--md"
                disabled={isDisabled}
                onClick={() => submitAction()}
            >
                ADD
            </button>
        </div>
    );
}

AddButton.propTypes = {
    id: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    submitAction: PropTypes.func.isRequired
};

AddButton.defaultProps = {
    isDisabled: false
};



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/AddButton.js